import { Pipe, PipeTransform } from '@angular/core';
import { REGEX } from '@common/constants/regex.constant';

@Pipe({
  name: 'userInitials'
})
export class UserInitialsPipe implements PipeTransform {

 transform(name?: string, limit: number = 2): string {
    if (!name) return '';

    return name
      .trim()
      .split(REGEX.WHITESPACE)               // split by spaces
      .filter(word => word.length > 0)
      .map(word => word.charAt(0))
      .join('')
      .substring(0, limit)        // default: 2 initials
      .toUpperCase();
  }

}
